import { withSvgIcon } from './withSvgIcon';

export const Mail = withSvgIcon(
  <path
    d="M19 9L12.9923 12.433C12.3774 12.7843 11.6226 12.7843 11.0077 12.433L5 9M6 18H18C19.1046 18 20 17.1046 20 16V8C20 6.89543 19.1046 6 18 6H6C4.89543 6 4 6.89543 4 8V16C4 17.1046 4.89543 18 6 18Z"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
